export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./src/axis";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-axis/index.js
// module id = ../../../../d3-axis/index.js
// module chunks = 4